import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function() {
    const sliderConfigs = {
        project: {
            selector: '.project-slider',
            options: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden'
                }
            }
        },
        testimonial: {
            selector: '.testimonials-slider',
            options: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                effect: "fade",
                fadeEffect: { crossFade: true },
                speed: 1000,
                pagination: {
                    el: '.testimonials-slider .testimonial-swiper-pagination',
                    clickable: true,
                    bulletClass: 'testimonial-swiper-pagination-bullet',
                    bulletActiveClass: 'testimonial-swiper-pagination-bullet-active',
                    renderBullet: function (index, className) {
                        return `
                            <span class="${className} relative w-3 h-3 mr-4 last:mr-0 transition-all duration-700 overflow-hidden" data-slide-index="${index}">
                                <span class="bullet-indicator absolute inset-0 bg-gray-100 rounded-full transition-all duration-300"></span>
                            </span>
                        `;
                    }
                },
                on: {
                    init: function(swiper) {
                        updateTestimonialPaginations(swiper, 'testimonial');
                    },
                    slideChange: function(swiper) {
                        updateTestimonialPaginations(swiper, 'testimonial');
                    },
                    realIndexChange: function(swiper) {
                        updateTestimonialPaginations(swiper, 'testimonial');
                    },
                    autoplayStart: function(swiper) {
                        updateTestimonialPaginations(swiper, 'testimonial');
                    }
                }
            }
        },
    };

    function initializeSlider(config, type) {
        const element = document.querySelector(config.selector);
        if (!element) return null;

        return new Swiper(config.selector, config.options);
    }

    function updateTestimonialPaginations(swiper, type) {
        const paginationContainers = swiper.el.querySelectorAll(`.${type}-swiper-pagination`);
        
        paginationContainers.forEach(container => {
            const bullets = container.querySelectorAll(`.${type}-swiper-pagination-bullet`);
            
            bullets.forEach((bullet, index) => {
                const isActive = index === swiper.realIndex;
                const indicator = bullet.querySelector('.bullet-indicator');

                if (isActive) {
                    indicator.classList.add('bg-gray-500');
                    indicator.classList.remove('bg-gray-100');
                } else {
                    indicator.classList.add('bg-gray-100');
                    indicator.classList.remove('bg-gray-500');
                }
            });
        });
    }

    initializeSlider(sliderConfigs.testimonial, 'testimonial');
    initializeSlider(sliderConfigs.project, 'project');

    initializeHeroSliders();
});

function initializeHeroSliders() {
    const sliders = document.querySelectorAll('.hero-slider[data-autoplay]');

    sliders.forEach(slider => {
        const autoplay = slider.dataset.autoplay === 'true';
        const delay = parseInt(slider.dataset.delay) || 5000;
        const effect = slider.dataset.effect || 'slide';
        const showPagination = slider.dataset.pagination === 'true';
        const showNavigation = slider.dataset.navigation === 'true';

        const options = {
            loop: true,
            slidesPerView: 1,
            speed: 500,
            effect: effect,
            autoplay: autoplay ? {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false,
            pagination: showPagination ? {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'hero-slider-bullet block w-2.5 h-2.5 rounded-full bg-white/50 transition-colors duration-300 cursor-pointer',
                bulletActiveClass: '!bg-white',
            } : false,
            navigation: showNavigation ? {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            } : false,
        };

        if (effect === 'fade') {
            options.fadeEffect = { crossFade: true };
        }

        new Swiper(slider, options);
    });
}
